var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wangEditor"},[_c('a-spin',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading"}),_c('div',{ref:"wang",staticStyle:{"white-space":"pre-wrap"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }